export type TemplatePageModel = {
  id: number,
  agency_ids?: number[],
  brand_id?: number,
  brand_theme_ids?: number[],
  cache_key?: number,
  data: any,
  designer_type?: string,
  in_use_count?: number,
  hidden?: boolean,
  origin_template_id?: number,
  preview_image?: string,
  service_id?: number,
  permission_ids?: {
    agencies: number[],
    brand_themes: number[],
    products: number[],
    providers: number[],
    publications: number[],
    template_groups: number[],
  },
  dimensions: {
    pixels: {
      bleed: {
        bottom: number,
        left: number,
        right: number,
        top: number,
      },
      height: number,
      width: number,
      safety_margin: {
        bottom: number,
        left: number,
        right: number,
        top: number,
      },
    },
  },
  production_ready?: boolean,
  title?: string,
  type?: 'TemplatePage',
  tags: number[] | null,
}

export type TemplatePageNewPermissions = {
  agency_ids?: number[],
  brand_theme_ids?: number[],
  provider_ids?: number[],
  publication_ids?: number[],
  service_product_ids?: number[],
  template_group_ids?: number[],
}

export type TemplatePageRequestOptions = {}

const state = {
  id: null,
  brand_id: null,
  cache_key: null,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'title' },
]

export default state
